<template>
  <div :class="loading ? 'cursor-wait' : ''">
    <medical-view :claim="claim" :modal="modalMedicalView" @closeModal="modalMedicalView = false" @refreshData="refreshData"></medical-view>
    <upload :claim="claim" :victim="victim.id" :file="optionSelected" :modal="modalUpload" @closeModalUpload="closeModalUpload"></upload>
    <traces :claim="claim" :modal="modalTrace" @closeModal="modalTrace = false"></traces>
    <userSearch :modal="modalUser" @closeModalUser="closeModalUser"></userSearch>
    <agreed-amount :claim="claim" :modal="modalAgreedAmount" @closeModal="modalAgreedAmount = false"></agreed-amount>
    <sign-attachments :claim="claim" :modal="modalSignAttachments" @closeModal="modalSignAttachments = false"></sign-attachments>
    <mercado-pago :claim="claim" :modal="modalMercadoPago" @closeModal="modalMercadoPago = false"></mercado-pago>
    <div v-if="modalMove" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all md:w-auto sm:w-full overflow-y-auto" role="dialog" aria-modal="true" aria-labelledby="modal-headline">  
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-md leading-6 font-medium text-gray-900" id="modal-headline">
                Mover Reclamo
              </h3>
              <div class="flex flex-col px-10 xl:px-0">
                <div class="py-4">
                    <div class="inline-block relative">
                      <select v-model="stateSelected" class="block appearance-none w-full bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                        <option v-for="s in states" :key="s.id" :value="s">{{ s.name }}</option>
                      </select>
                      <span v-if="modalMoveError" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                        {{ modalMoveError }} 
                      </span>
                      <div class="pointer-events-none absolute inset-y-0 right-0 flex items-center px-2 text-gray-700">
                        <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                      </div>
                    </div>
                </div>  
                <div class="py-4" v-if="stateSelected && stateSelected.id == statePendingCommission">
                    <input v-model="linkMercadoPago" type="text" placeholder="Link Mercadopago" :class="linkMercadoPagoError != null ? 'border-red-500' : ''" class="text-sm w-3/3 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                    <span v-if="linkMercadoPagoError" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                      {{ linkMercadoPagoError }}
                    </span>
                </div> 
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="modalMove = false"
              :disabled="loading"
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-red-300 px-4 py-2 bg-white text-base leading-6 font-medium text-red-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                </path>
              </svg>
              Cancelar
            </button>
          </span>

          <span class="mt-3 flex w-full rounded-md shadow-sm sm:mt-0 sm:w-auto">
            <button 
              @click="move"
              :disabled="loading"
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-green-300 px-4 py-2 bg-white text-base leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >
                <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                </path>
              </svg>
              Aceptar
            </button>
          </span>

          <span class="pr-4">
            <div v-if="loading">
                <svg width="38" height="38" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#338BFF">
                    <g fill="none" fill-rule="evenodd">
                        <g transform="translate(1 1)" stroke-width="2">
                            <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                            <path d="M36 18c0-9.94-8.06-18-18-18">
                                <animateTransform
                                    attributeName="transform"
                                    type="rotate"
                                    from="0 18 18"
                                    to="360 18 18"
                                    dur="1s"
                                    repeatCount="indefinite"/>
                            </path>
                        </g>
                    </g>
                </svg>
            </div>
          </span>
        </div>
      </div>
    </div>

    <div v-if="modalVictim" class="fixed bottom-0 inset-x-0 px-4 pb-4 sm:inset-0 sm:flex sm:items-center sm:justify-center">
      <div class="fixed inset-0 transition-opacity">
        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
      </div>
      <div class="bg-white rounded-lg overflow-hidden shadow-xl transform transition-all sm:max-w-lg sm:w-full overflow-y-auto" role="dialog" aria-modal="true" aria-labelledby="modal-headline" style="max-height: 70vh;">
        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
          <div class="sm:flex sm:items-start">
            <div class="w-full mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">            
              <h3 class="text-md leading-6 font-medium text-gray-900" id="modal-headline" v-if="victim.person">
                {{ victim.person.name }}
              </h3>
              <div class="flex flex-col px-10 xl:px-0">
                <table class="min-w-full">
                  <thead v-for="vf in victimFiles" :key="vf.id">
                    <tr @click="toogleFileOptions(vf)">
                      <th
                        class="flex items-center justify-between px-6 py-3 text-xs font-medium leading-4 tracking-wider text-blue-500 uppercase border-b border-blue-200 bg-blue-50"
                      >
                        <img v-if="vf.icon" :src="require('../assets/files/'+vf.icon)" />
                        <span>{{ vf.name }}</span>
                        <svg
                          class="w-5 h-5 mr-2 -ml-1 text-white-400 cursor-pointer"
                          fill="currentColor"
                          viewBox="0 0 20 20"
                        >
                          <path
                            v-if="!vf.active"
                            d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10"
                          ></path>
                          <path 
                            v-if="vf.active"
                            d="M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z M13.388,9.624H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h6.775c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z">
                          </path>
                        </svg>
                      </th>
                    </tr>
                    <tr v-for="o in vf.options" :key="o.id" v-show="vf.active">
                      <td 
                        :class="[o.loaded ? 'text-gray-500' : 'text-red-500']"
                        class="flex items-center justify-between px-6 py-3 text-xs font-medium leading-4 tracking-wider uppercase border-b border-gray-200 bg-gray-50">
                          {{ o.name }}
                          <span class="flex items-center">
                            <a v-if="!o.loaded && !o.plus" href="#" @click="uploadFile(o)" class="pr-2">
                              <svg
                                class="w-5 h-5 mr-2 -ml-1 text-green-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M8.416,3.943l1.12-1.12v9.031c0,0.257,0.208,0.464,0.464,0.464c0.256,0,0.464-0.207,0.464-0.464V2.823l1.12,1.12c0.182,0.182,0.476,0.182,0.656,0c0.182-0.181,0.182-0.475,0-0.656l-1.744-1.745c-0.018-0.081-0.048-0.16-0.112-0.224C10.279,1.214,10.137,1.177,10,1.194c-0.137-0.017-0.279,0.02-0.384,0.125C9.551,1.384,9.518,1.465,9.499,1.548L7.76,3.288c-0.182,0.181-0.182,0.475,0,0.656C7.941,4.125,8.234,4.125,8.416,3.943z M15.569,6.286h-2.32v0.928h2.32c0.512,0,0.928,0.416,0.928,0.928v8.817c0,0.513-0.416,0.929-0.928,0.929H4.432c-0.513,0-0.928-0.416-0.928-0.929V8.142c0-0.513,0.416-0.928,0.928-0.928h2.32V6.286h-2.32c-1.025,0-1.856,0.831-1.856,1.856v8.817c0,1.025,0.832,1.856,1.856,1.856h11.138c1.024,0,1.855-0.831,1.855-1.856V8.142C17.425,7.117,16.594,6.286,15.569,6.286z">
                                </path>
                              </svg>
                            </a>
                            <a v-if="o.loaded && !o.plus" href="#" @click="downloadVictimFile(o)" class="pr-2">
                              <svg
                                class="w-5 h-5 mr-2 -ml-1 text-green-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                                </path>
                              </svg>
                            </a>
                            <a v-if="o.loaded && !o.plus" href="#" @click="removeVictimFile(o)">
                              <svg
                                class="w-5 h-5 mr-2 -ml-1 text-red-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M12.71,7.291c-0.15-0.15-0.393-0.15-0.542,0L10,9.458L7.833,7.291c-0.15-0.15-0.392-0.15-0.542,0c-0.149,0.149-0.149,0.392,0,0.541L9.458,10l-2.168,2.167c-0.149,0.15-0.149,0.393,0,0.542c0.15,0.149,0.392,0.149,0.542,0L10,10.542l2.168,2.167c0.149,0.149,0.392,0.149,0.542,0c0.148-0.149,0.148-0.392,0-0.542L10.542,10l2.168-2.168C12.858,7.683,12.858,7.44,12.71,7.291z M10,1.188c-4.867,0-8.812,3.946-8.812,8.812c0,4.867,3.945,8.812,8.812,8.812s8.812-3.945,8.812-8.812C18.812,5.133,14.867,1.188,10,1.188z M10,18.046c-4.444,0-8.046-3.603-8.046-8.046c0-4.444,3.603-8.046,8.046-8.046c4.443,0,8.046,3.602,8.046,8.046C18.046,14.443,14.443,18.046,10,18.046z">
                                </path>
                              </svg>
                            </a>
                            <a v-if="o.plus && o.loaded && othersVictimUploads.typeFileId != vf.id" href="#" @click="viewVictimOthersUpload(o)" class="pr-2">
                              <svg
                                class="w-6 h-6 mr-2 -ml-1 text-gray-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M10,6.978c-1.666,0-3.022,1.356-3.022,3.022S8.334,13.022,10,13.022s3.022-1.356,3.022-3.022S11.666,6.978,10,6.978M10,12.267c-1.25,0-2.267-1.017-2.267-2.267c0-1.25,1.016-2.267,2.267-2.267c1.251,0,2.267,1.016,2.267,2.267C12.267,11.25,11.251,12.267,10,12.267 M18.391,9.733l-1.624-1.639C14.966,6.279,12.563,5.278,10,5.278S5.034,6.279,3.234,8.094L1.609,9.733c-0.146,0.147-0.146,0.386,0,0.533l1.625,1.639c1.8,1.815,4.203,2.816,6.766,2.816s4.966-1.001,6.767-2.816l1.624-1.639C18.536,10.119,18.536,9.881,18.391,9.733 M16.229,11.373c-1.656,1.672-3.868,2.594-6.229,2.594s-4.573-0.922-6.23-2.594L2.41,10l1.36-1.374C5.427,6.955,7.639,6.033,10,6.033s4.573,0.922,6.229,2.593L17.59,10L16.229,11.373z">
                                </path>
                              </svg>
                            </a>
                            <a v-if="o.plus && o.loaded && othersVictimUploads.typeFileId == vf.id" href="#" @click="othersVictimUploads.typeFileId = null" class="pr-2">
                              <svg
                                class="w-5 h-5 mr-2 -ml-1 text-orange-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z M13.388,9.624H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h6.775c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z">
                                </path>
                              </svg>
                            </a>
                            <a v-if="o.plus && othersVictimUploads.typeFileId != vf.id" href="#" @click="uploadFile(o)" class="pr-2">
                              <svg
                                class="w-5 h-5 mr-2 -ml-1 text-blue-500"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                              >
                                <path d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10">
                                </path>
                              </svg>
                            </a>
                          </span>
                      </td>
                    </tr>
                    <tr v-for="(other, index) in othersVictimUploads.files" :key="other.name+index" v-show="othersVictimUploads.typeFileId == vf.id">
                      <td 
                        class="flex items-center justify-between px-6 py-3 text-black-500 text-xs font-medium leading-4 tracking-wider uppercase border-b border-gray-200 bg-gray-300">
                        {{ other.name }} {{ index+1 }}
                        <span class="flex items-center">
                          <a href="#" @click="downloadVictimOtherFile(other)" class="pr-2">
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-green-500"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                              </path>
                            </svg>
                          </a>
                          <a href="#" @click="removeVictimOtherFile(other)">
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-red-500"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M12.71,7.291c-0.15-0.15-0.393-0.15-0.542,0L10,9.458L7.833,7.291c-0.15-0.15-0.392-0.15-0.542,0c-0.149,0.149-0.149,0.392,0,0.541L9.458,10l-2.168,2.167c-0.149,0.15-0.149,0.393,0,0.542c0.15,0.149,0.392,0.149,0.542,0L10,10.542l2.168,2.167c0.149,0.149,0.392,0.149,0.542,0c0.148-0.149,0.148-0.392,0-0.542L10.542,10l2.168-2.168C12.858,7.683,12.858,7.44,12.71,7.291z M10,1.188c-4.867,0-8.812,3.946-8.812,8.812c0,4.867,3.945,8.812,8.812,8.812s8.812-3.945,8.812-8.812C18.812,5.133,14.867,1.188,10,1.188z M10,18.046c-4.444,0-8.046-3.603-8.046-8.046c0-4.444,3.603-8.046,8.046-8.046c4.443,0,8.046,3.602,8.046,8.046C18.046,14.443,14.443,18.046,10,18.046z">
                              </path>
                            </svg>
                          </a>
                        </span>
                      </td>
                    </tr>
                  </thead>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div class="bg-gray-50 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
          <span class="flex w-full rounded-md shadow-sm sm:ml-3 sm:w-auto">
            <button 
              @click="closeModalVictim"
              type="button" 
              class="inline-flex justify-center w-full rounded-md border border-gray-300 px-4 py-2 bg-white text-base leading-6 font-medium text-grey-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg
                class="w-5 h-5 mr-2 -ml-1 text-white-400"
                fill="currentColor"
                viewBox="0 0 20 20"
              >  
                <path d="M3.24,7.51c-0.146,0.142-0.146,0.381,0,0.523l5.199,5.193c0.234,0.238,0.633,0.064,0.633-0.262v-2.634c0.105-0.007,0.212-0.011,0.321-0.011c2.373,0,4.302,1.91,4.302,4.258c0,0.957-0.33,1.809-1.008,2.602c-0.259,0.307,0.084,0.762,0.451,0.572c2.336-1.195,3.73-3.408,3.73-5.924c0-3.741-3.103-6.783-6.916-6.783c-0.307,0-0.615,0.028-0.881,0.063V2.575c0-0.327-0.398-0.5-0.633-0.261L3.24,7.51 M4.027,7.771l4.301-4.3v2.073c0,0.232,0.21,0.409,0.441,0.366c0.298-0.056,0.746-0.123,1.184-0.123c3.402,0,6.172,2.709,6.172,6.041c0,1.695-0.718,3.24-1.979,4.352c0.193-0.51,0.293-1.045,0.293-1.602c0-2.76-2.266-5-5.046-5c-0.256,0-0.528,0.018-0.747,0.05C8.465,9.653,8.328,9.81,8.328,9.995v2.074L4.027,7.771z">
                </path>
              </svg>
              Volver
            </button>
          </span>
        </div>
      </div>
    </div>

    <div class="pl-4 pr-4 pb-1" v-if="claim.id != null">
      <div class="flex justify-between items-center px-5 py-3 bg-orange-100 text-gray-700 border rounded-md">
        <div class="flex text-sm">
          <svg
            v-if="claim"
            @click="modalTrace = true"
            class="w-10 h-10 mr-2 -ml-1 text-gray-400 cursor-pointer"
            fill="currentColor"
            viewBox="0 0 20 20"
          >
            <path d="M10,1.445c-4.726,0-8.555,3.829-8.555,8.555c0,4.725,3.829,8.555,8.555,8.555c4.725,0,8.555-3.83,8.555-8.555C18.555,5.274,14.725,1.445,10,1.445 M10,17.654c-4.221,0-7.654-3.434-7.654-7.654c0-4.221,3.433-7.654,7.654-7.654c4.222,0,7.654,3.433,7.654,7.654C17.654,14.221,14.222,17.654,10,17.654 M14.39,10c0,0.248-0.203,0.45-0.45,0.45H6.06c-0.248,0-0.45-0.203-0.45-0.45s0.203-0.45,0.45-0.45h7.879C14.187,9.55,14.39,9.752,14.39,10 M14.39,12.702c0,0.247-0.203,0.449-0.45,0.449H6.06c-0.248,0-0.45-0.202-0.45-0.449c0-0.248,0.203-0.451,0.45-0.451h7.879C14.187,12.251,14.39,12.454,14.39,12.702 M14.39,7.298c0,0.248-0.203,0.45-0.45,0.45H6.06c-0.248,0-0.45-0.203-0.45-0.45s0.203-0.45,0.45-0.45h7.879C14.187,6.848,14.39,7.051,14.39,7.298">
            </path>
          </svg>

          <div class="flex items-stretch" v-if="claim && claim.state">
            <svg
              v-if="claim.state.id == stateMedicalView || ((claim.state.id == stateInicial || claim.state.id == stateComplete) && claim.medical)"
              @click="modalMedicalView = true"
              class="w-8 h-8 mr-2 -ml-1 text-red-600 cursor-pointer pt-2"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M17 10.27V4.99a1 1 0 0 0-2 0V15a5 5 0 0 1-10 0v-1.08A6 6 0 0 1 0 8V2C0 .9.9 0 2 0h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1H2v6a4 4 0 1 0 8 0V2H9a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v6a6 6 0 0 1-5 5.92V15a3 3 0 0 0 6 0V5a3 3 0 0 1 6 0v5.27a2 2 0 1 1-2 0z">
              </path>
            </svg>
            <svg
              v-else-if="claim.medical"
              class="w-8 h-8 mr-2 -ml-1 text-red-600 pt-2"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M17 10.27V4.99a1 1 0 0 0-2 0V15a5 5 0 0 1-10 0v-1.08A6 6 0 0 1 0 8V2C0 .9.9 0 2 0h1a1 1 0 0 1 1 1 1 1 0 0 1-1 1H2v6a4 4 0 1 0 8 0V2H9a1 1 0 0 1-1-1 1 1 0 0 1 1-1h1a2 2 0 0 1 2 2v6a6 6 0 0 1-5 5.92V15a3 3 0 0 0 6 0V5a3 3 0 0 1 6 0v5.27a2 2 0 1 1-2 0z">
              </path>
            </svg>
            <svg
              v-if="claim.state.id == stateInNegotiation"
              @click="modalAgreedAmount = true"
              class="w-10 h-10 mr-2 -ml-1 text-blue-600 cursor-pointer"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M5.229,6.531H4.362c-0.239,0-0.434,0.193-0.434,0.434c0,0.239,0.194,0.434,0.434,0.434h0.868c0.24,0,0.434-0.194,0.434-0.434C5.663,6.724,5.469,6.531,5.229,6.531 M10,6.531c-1.916,0-3.47,1.554-3.47,3.47c0,1.916,1.554,3.47,3.47,3.47c1.916,0,3.47-1.555,3.47-3.47C13.47,8.084,11.916,6.531,10,6.531 M11.4,11.447c-0.071,0.164-0.169,0.299-0.294,0.406c-0.124,0.109-0.27,0.191-0.437,0.248c-0.167,0.057-0.298,0.09-0.492,0.098v0.402h-0.35v-0.402c-0.21-0.004-0.352-0.039-0.527-0.1c-0.175-0.064-0.324-0.154-0.449-0.27c-0.124-0.115-0.221-0.258-0.288-0.428c-0.068-0.17-0.1-0.363-0.096-0.583h0.664c-0.004,0.259,0.052,0.464,0.169,0.613c0.116,0.15,0.259,0.229,0.527,0.236v-1.427c-0.159-0.043-0.268-0.095-0.425-0.156c-0.157-0.061-0.299-0.139-0.425-0.235C8.852,9.752,8.75,9.631,8.672,9.486C8.594,9.34,8.556,9.16,8.556,8.944c0-0.189,0.036-0.355,0.108-0.498c0.072-0.144,0.169-0.264,0.292-0.36c0.122-0.097,0.263-0.17,0.422-0.221c0.159-0.052,0.277-0.077,0.451-0.077V7.401h0.35v0.387c0.174,0,0.29,0.023,0.445,0.071c0.155,0.047,0.29,0.118,0.404,0.212c0.115,0.095,0.206,0.215,0.274,0.359c0.067,0.146,0.103,0.315,0.103,0.508H10.74c-0.007-0.201-0.06-0.354-0.154-0.46c-0.096-0.106-0.199-0.159-0.408-0.159v1.244c0.174,0.047,0.296,0.102,0.462,0.165c0.167,0.063,0.314,0.144,0.443,0.241c0.128,0.099,0.23,0.221,0.309,0.366c0.077,0.146,0.116,0.324,0.116,0.536C11.509,11.092,11.473,11.283,11.4,11.447 M18.675,4.795H1.326c-0.479,0-0.868,0.389-0.868,0.868v8.674c0,0.479,0.389,0.867,0.868,0.867h17.349c0.479,0,0.867-0.389,0.867-0.867V5.664C19.542,5.184,19.153,4.795,18.675,4.795M1.76,5.664c0.24,0,0.434,0.193,0.434,0.434C2.193,6.336,2,6.531,1.76,6.531S1.326,6.336,1.326,6.097C1.326,5.857,1.52,5.664,1.76,5.664 M1.76,14.338c-0.24,0-0.434-0.195-0.434-0.434c0-0.24,0.194-0.434,0.434-0.434s0.434,0.193,0.434,0.434C2.193,14.143,2,14.338,1.76,14.338 M18.241,14.338c-0.24,0-0.435-0.195-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,14.143,18.48,14.338,18.241,14.338 M18.675,12.682c-0.137-0.049-0.281-0.08-0.434-0.08c-0.719,0-1.302,0.584-1.302,1.303c0,0.152,0.031,0.297,0.08,0.434H2.981c0.048-0.137,0.08-0.281,0.08-0.434c0-0.719-0.583-1.303-1.301-1.303c-0.153,0-0.297,0.031-0.434,0.08V7.318c0.136,0.049,0.28,0.08,0.434,0.08c0.718,0,1.301-0.583,1.301-1.301c0-0.153-0.032-0.298-0.08-0.434H17.02c-0.049,0.136-0.08,0.28-0.08,0.434c0,0.718,0.583,1.301,1.302,1.301c0.152,0,0.297-0.031,0.434-0.08V12.682z M18.241,6.531c-0.24,0-0.435-0.194-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,6.336,18.48,6.531,18.241,6.531 M9.22,8.896c0,0.095,0.019,0.175,0.058,0.242c0.039,0.066,0.088,0.124,0.148,0.171c0.061,0.047,0.13,0.086,0.21,0.115c0.079,0.028,0.11,0.055,0.192,0.073V8.319c-0.21,0-0.322,0.044-0.437,0.132C9.277,8.54,9.22,8.688,9.22,8.896 M15.639,12.602h-0.868c-0.239,0-0.434,0.195-0.434,0.434c0,0.24,0.194,0.436,0.434,0.436h0.868c0.24,0,0.434-0.195,0.434-0.436C16.072,12.797,15.879,12.602,15.639,12.602 M10.621,10.5c-0.068-0.052-0.145-0.093-0.23-0.124c-0.086-0.031-0.123-0.06-0.212-0.082v1.374c0.209-0.016,0.332-0.076,0.465-0.186c0.134-0.107,0.201-0.281,0.201-0.516c0-0.11-0.02-0.202-0.062-0.277C10.743,10.615,10.688,10.551,10.621,10.5"></path>
            </svg>
            <svg
              v-if="claim.state.id == statePendingPayment || claim.state.id == statePendingCommission || claim.state.id == stateClosed"
              @click="viewInfoPayment(claim)"
              class="w-10 h-10 mr-2 -ml-1 text-blue-600 cursor-pointer"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M5.229,6.531H4.362c-0.239,0-0.434,0.193-0.434,0.434c0,0.239,0.194,0.434,0.434,0.434h0.868c0.24,0,0.434-0.194,0.434-0.434C5.663,6.724,5.469,6.531,5.229,6.531 M10,6.531c-1.916,0-3.47,1.554-3.47,3.47c0,1.916,1.554,3.47,3.47,3.47c1.916,0,3.47-1.555,3.47-3.47C13.47,8.084,11.916,6.531,10,6.531 M11.4,11.447c-0.071,0.164-0.169,0.299-0.294,0.406c-0.124,0.109-0.27,0.191-0.437,0.248c-0.167,0.057-0.298,0.09-0.492,0.098v0.402h-0.35v-0.402c-0.21-0.004-0.352-0.039-0.527-0.1c-0.175-0.064-0.324-0.154-0.449-0.27c-0.124-0.115-0.221-0.258-0.288-0.428c-0.068-0.17-0.1-0.363-0.096-0.583h0.664c-0.004,0.259,0.052,0.464,0.169,0.613c0.116,0.15,0.259,0.229,0.527,0.236v-1.427c-0.159-0.043-0.268-0.095-0.425-0.156c-0.157-0.061-0.299-0.139-0.425-0.235C8.852,9.752,8.75,9.631,8.672,9.486C8.594,9.34,8.556,9.16,8.556,8.944c0-0.189,0.036-0.355,0.108-0.498c0.072-0.144,0.169-0.264,0.292-0.36c0.122-0.097,0.263-0.17,0.422-0.221c0.159-0.052,0.277-0.077,0.451-0.077V7.401h0.35v0.387c0.174,0,0.29,0.023,0.445,0.071c0.155,0.047,0.29,0.118,0.404,0.212c0.115,0.095,0.206,0.215,0.274,0.359c0.067,0.146,0.103,0.315,0.103,0.508H10.74c-0.007-0.201-0.06-0.354-0.154-0.46c-0.096-0.106-0.199-0.159-0.408-0.159v1.244c0.174,0.047,0.296,0.102,0.462,0.165c0.167,0.063,0.314,0.144,0.443,0.241c0.128,0.099,0.23,0.221,0.309,0.366c0.077,0.146,0.116,0.324,0.116,0.536C11.509,11.092,11.473,11.283,11.4,11.447 M18.675,4.795H1.326c-0.479,0-0.868,0.389-0.868,0.868v8.674c0,0.479,0.389,0.867,0.868,0.867h17.349c0.479,0,0.867-0.389,0.867-0.867V5.664C19.542,5.184,19.153,4.795,18.675,4.795M1.76,5.664c0.24,0,0.434,0.193,0.434,0.434C2.193,6.336,2,6.531,1.76,6.531S1.326,6.336,1.326,6.097C1.326,5.857,1.52,5.664,1.76,5.664 M1.76,14.338c-0.24,0-0.434-0.195-0.434-0.434c0-0.24,0.194-0.434,0.434-0.434s0.434,0.193,0.434,0.434C2.193,14.143,2,14.338,1.76,14.338 M18.241,14.338c-0.24,0-0.435-0.195-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,14.143,18.48,14.338,18.241,14.338 M18.675,12.682c-0.137-0.049-0.281-0.08-0.434-0.08c-0.719,0-1.302,0.584-1.302,1.303c0,0.152,0.031,0.297,0.08,0.434H2.981c0.048-0.137,0.08-0.281,0.08-0.434c0-0.719-0.583-1.303-1.301-1.303c-0.153,0-0.297,0.031-0.434,0.08V7.318c0.136,0.049,0.28,0.08,0.434,0.08c0.718,0,1.301-0.583,1.301-1.301c0-0.153-0.032-0.298-0.08-0.434H17.02c-0.049,0.136-0.08,0.28-0.08,0.434c0,0.718,0.583,1.301,1.302,1.301c0.152,0,0.297-0.031,0.434-0.08V12.682z M18.241,6.531c-0.24,0-0.435-0.194-0.435-0.434c0-0.24,0.194-0.434,0.435-0.434c0.239,0,0.434,0.193,0.434,0.434C18.675,6.336,18.48,6.531,18.241,6.531 M9.22,8.896c0,0.095,0.019,0.175,0.058,0.242c0.039,0.066,0.088,0.124,0.148,0.171c0.061,0.047,0.13,0.086,0.21,0.115c0.079,0.028,0.11,0.055,0.192,0.073V8.319c-0.21,0-0.322,0.044-0.437,0.132C9.277,8.54,9.22,8.688,9.22,8.896 M15.639,12.602h-0.868c-0.239,0-0.434,0.195-0.434,0.434c0,0.24,0.194,0.436,0.434,0.436h0.868c0.24,0,0.434-0.195,0.434-0.436C16.072,12.797,15.879,12.602,15.639,12.602 M10.621,10.5c-0.068-0.052-0.145-0.093-0.23-0.124c-0.086-0.031-0.123-0.06-0.212-0.082v1.374c0.209-0.016,0.332-0.076,0.465-0.186c0.134-0.107,0.201-0.281,0.201-0.516c0-0.11-0.02-0.202-0.062-0.277C10.743,10.615,10.688,10.551,10.621,10.5"></path>
            </svg>
            <svg
              v-if="claim.state.id == statePendingPayment"
              @click="modalSignAttachments = true"
              class="w-10 h-10 mr-2 -ml-1 text-black cursor-pointer"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M4.317,16.411c-1.423-1.423-1.423-3.737,0-5.16l8.075-7.984c0.994-0.996,2.613-0.996,3.611,0.001C17,4.264,17,5.884,16.004,6.88l-8.075,7.984c-0.568,0.568-1.493,0.569-2.063-0.001c-0.569-0.569-0.569-1.495,0-2.064L9.93,8.828c0.145-0.141,0.376-0.139,0.517,0.005c0.141,0.144,0.139,0.375-0.006,0.516l-4.062,3.968c-0.282,0.282-0.282,0.745,0.003,1.03c0.285,0.284,0.747,0.284,1.032,0l8.074-7.985c0.711-0.71,0.711-1.868-0.002-2.579c-0.711-0.712-1.867-0.712-2.58,0l-8.074,7.984c-1.137,1.137-1.137,2.988,0.001,4.127c1.14,1.14,2.989,1.14,4.129,0l6.989-6.896c0.143-0.142,0.375-0.14,0.516,0.003c0.143,0.143,0.141,0.374-0.002,0.516l-6.988,6.895C8.054,17.836,5.743,17.836,4.317,16.411"></path>
            </svg>

            <img 
              v-if="claim.state.id == statePendingCommission"
              @click="modalMercadoPago = true"
              class="w-10 h-10 mr-2 -ml-1 cursor-pointer" 
              :src="require('../assets/images/mercadopago.png')" 
            />
          </div>
        </div>

        <div 
          v-if="claim.state" 
          class="flex justify-center items-center m-1 py-1 px-2 rounded-full text-purple-700 bg-purple-100 border border-purple-300 cursor-pointer"
          @click="modalMove = true; modalMoveError = null; loading = false; stateSelected = null"
          >
            <div class="text-xs font-xs leading-none max-w-full flex-initial">{{ claim.state.name }}</div>
            <svg
              class="w-8 h-8 mr-2 -ml-1"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
              <path d="M16.198,10.896c-0.252,0-0.455,0.203-0.455,0.455v2.396c0,0.626-0.511,1.137-1.138,1.137H5.117c-0.627,0-1.138-0.511-1.138-1.137V7.852c0-0.626,0.511-1.137,1.138-1.137h5.315c0.252,0,0.456-0.203,0.456-0.455c0-0.251-0.204-0.455-0.456-0.455H5.117c-1.129,0-2.049,0.918-2.049,2.047v5.894c0,1.129,0.92,2.048,2.049,2.048h9.488c1.129,0,2.048-0.919,2.048-2.048v-2.396C16.653,11.099,16.45,10.896,16.198,10.896z"></path>
              <path d="M14.053,4.279c-0.207-0.135-0.492-0.079-0.63,0.133c-0.137,0.211-0.077,0.493,0.134,0.63l1.65,1.073c-4.115,0.62-5.705,4.891-5.774,5.082c-0.084,0.236,0.038,0.495,0.274,0.581c0.052,0.019,0.103,0.027,0.154,0.027c0.186,0,0.361-0.115,0.429-0.301c0.014-0.042,1.538-4.023,5.238-4.482l-1.172,1.799c-0.137,0.21-0.077,0.492,0.134,0.629c0.076,0.05,0.163,0.074,0.248,0.074c0.148,0,0.294-0.073,0.382-0.207l1.738-2.671c0.066-0.101,0.09-0.224,0.064-0.343c-0.025-0.118-0.096-0.221-0.197-0.287L14.053,4.279z"></path>
            </svg>
        </div>
        
        <div v-if="chat" :class="[chat.noread > 0 ? 'text-red-400' : 'text-green-400']" class="flex text-sm">
          <router-link v-if="claim" :to="{ name: 'Chat', params: { claimId: claim.id }}">
            <svg
              :class="[chat.noread > 0 ? 'text-red-400' : 'text-green-400']"
              class="w-10 h-10 mr-2 -ml-1"
              fill="currentColor"
              viewBox="0 0 20 20"
            >
            <path d="M14.9,6.707c-0.804-2.497-3.649-4.351-7.035-4.351c-4.008,0-7.27,2.594-7.27,5.782
              c0,2.163,1.516,4.133,3.903,5.122v3.091c0,0.251,0.144,0.478,0.372,0.586c0.087,0.042,0.182,0.062,0.276,0.062
              c0.148,0,0.295-0.051,0.412-0.15l3.678-3.038c0.14-0.022,0.275-0.057,0.413-0.084c0.655,0.666,1.544,1.185,2.607,1.46
              c0.198,0.051,0.401,0.094,0.608,0.125l2.641,2.182c0.118,0.099,0.264,0.15,0.413,0.15c0.094,0,0.188-0.02,0.276-0.062
              c0.228-0.108,0.372-0.335,0.372-0.586v-2.135c1.74-0.761,2.84-2.231,2.84-3.846C19.405,8.862,17.456,7.073,14.9,6.707z
              M8.885,12.552c-0.019,0.003-0.032,0.018-0.051,0.022c-0.101,0.022-0.2,0.056-0.281,0.123l-2.76,2.28v-2.161
              c0-0.275-0.175-0.521-0.434-0.612C3.253,11.467,1.89,9.871,1.89,8.138c0-2.474,2.68-4.487,5.975-4.487
              c2.604,0,4.801,1.265,5.617,3.014c0.187,0.401,0.302,0.823,0.33,1.268c0.005,0.069,0.028,0.134,0.028,0.205
              c0,1.819-1.481,3.438-3.706,4.129c-0.115,0.037-0.224,0.08-0.343,0.111C9.497,12.455,9.196,12.513,8.885,12.552z M15.703,13.809
              c-0.259,0.091-0.434,0.336-0.434,0.612v1.199l-1.723-1.422c-0.095-0.079-0.211-0.129-0.333-0.144
              c-0.219-0.028-0.431-0.068-0.636-0.121c-0.545-0.14-1.023-0.364-1.433-0.64c2.423-0.969,3.99-2.942,3.99-5.155
              c0-0.024-0.004-0.047-0.005-0.071c1.718,0.385,2.98,1.553,2.98,2.948C18.11,12.202,17.165,13.299,15.703,13.809z"></path>
            <path d="M4.68,7.591h6.167c0.358,0,0.648-0.29,0.648-0.648s-0.29-0.648-0.648-0.648H4.68
              c-0.358,0-0.648,0.29-0.648,0.648S4.323,7.591,4.68,7.591z"></path>
            <path d="M8.709,8.636H4.68c-0.358,0-0.648,0.29-0.648,0.648c0,0.358,0.29,0.648,0.648,0.648h4.028
              c0.358,0,0.648-0.29,0.648-0.648C9.356,8.926,9.067,8.636,8.709,8.636z"></path>
            </svg>
          </router-link>
          ({{ chat.noread }})
        </div>
        
      </div>
    </div>
    
    <div class="pl-4 pr-4">
      <div class="w-full bg-white shadow-md rounded-md overflow-hidden border">
        <div class="flex justify-between items-center px-5 py-3 bg-blue-50 text-gray-700 border-b">
            <h3 class="text-sm" v-if="!user.id">
              Cliente
              <svg @click="modalUser = true" class="inline-flex h-4 w-4 text-green-800 cursor-pointer" fill="currentColor" viewBox="0 0 24 24">
                <path d="M18.125,15.804l-4.038-4.037c0.675-1.079,1.012-2.308,1.01-3.534C15.089,4.62,12.199,1.75,8.584,1.75C4.815,1.75,1.982,4.726,2,8.286c0.021,3.577,2.908,6.549,6.578,6.549c1.241,0,2.417-0.347,3.44-0.985l4.032,4.026c0.167,0.166,0.43,0.166,0.596,0l1.479-1.478C18.292,16.234,18.292,15.968,18.125,15.804 M8.578,13.99c-3.198,0-5.716-2.593-5.733-5.71c-0.017-3.084,2.438-5.686,5.74-5.686c3.197,0,5.625,2.493,5.64,5.624C14.242,11.548,11.621,13.99,8.578,13.99 M16.349,16.981l-3.637-3.635c0.131-0.11,0.721-0.695,0.876-0.884l3.642,3.639L16.349,16.981z">
                </path>
              </svg>
            </h3>
            <h3 class="text-sm" v-if="user.id">{{ user.name }} ({{ user.email }})</h3>

            <button @click="userShow = !userShow">
                <svg class="h-4 w-4 text-gray-800 cursor-pointer" fill="currentColor" viewBox="0 0 24 24">
                    <path v-if="userShow" d="M14.776,10c0,0.239-0.195,0.434-0.435,0.434H5.658c-0.239,0-0.434-0.195-0.434-0.434s0.195-0.434,0.434-0.434h8.684C14.581,9.566,14.776,9.762,14.776,10 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.691-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.382,10c0-4.071-3.312-7.381-7.382-7.381C5.929,2.619,2.619,5.93,2.619,10c0,4.07,3.311,7.382,7.381,7.382C14.07,17.383,17.382,14.07,17.382,10"></path>
                    <path v-if="!userShow" d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10"></path>
                </svg>
            </button>
            
        </div>
        
        <div class="px-5 py-6 bg-gray-100" v-if="userShow">
            <div class="flex flex-wrap">
              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="user.email" type="text" placeholder="E-mail" :class="errors.email != null ? 'border-red-500' : ''" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                  <span v-if="errors.email != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.email }}
                  </span>
              </div>

              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="user.identity_number" type="number" placeholder="DNI" :class="errors.identity_number != null ? 'border-red-500' : ''" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                  <span v-if="errors.identity_number != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.identity_number }}
                  </span>
              </div>

              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="user.name" type="text" :class="errors.name != null ? 'border-red-500' : ''" placeholder="Nombre y Apellido" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                  <span v-if="errors.name != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.name }}
                  </span>
              </div>

              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="user.tel" type="text" placeholder="Teléfono" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
              </div>
            </div>
        </div>

        <div class="flex justify-end items-center px-5 py-3 bg-blue-50 border-t" v-if="userShow">
            <button 
              @click="saveUser" 
              :disabled="loading" 
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex rounded-md border border-green-300 px-4 py-2 bg-white text-sm leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg class="w-5 h-5 mr-2 -ml-1 text-white-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"></path>
              </svg>
              Aceptar
            </button>
        </div>
      </div>
    </div>

    <div class="pl-4 pr-4 pt-2" v-if="user.id">
      <div class="w-full bg-white shadow-md rounded-md overflow-hidden border">
        <div class="flex justify-between items-center px-5 py-3 bg-blue-50 text-gray-700 border-b">
            <h3 class="text-sm">SOBRE EL ACCIDENTE</h3>
            <button @click="accidentWho = !accidentWho">
                <svg class="h-4 w-4 text-gray-800 cursor-pointer" fill="currentColor" viewBox="0 0 24 24">
                    <path v-if="accidentWho" d="M14.776,10c0,0.239-0.195,0.434-0.435,0.434H5.658c-0.239,0-0.434-0.195-0.434-0.434s0.195-0.434,0.434-0.434h8.684C14.581,9.566,14.776,9.762,14.776,10 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.691-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.382,10c0-4.071-3.312-7.381-7.382-7.381C5.929,2.619,2.619,5.93,2.619,10c0,4.07,3.311,7.382,7.381,7.382C14.07,17.383,17.382,14.07,17.382,10"></path>
                    <path v-if="!accidentWho" d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10"></path>
                </svg>
            </button>
        </div>
        
        <div class="px-5 py-6 bg-gray-100" v-if="accidentWho">
            <div class="flex justify-between items-center px-5 py-3 bg-green-50 text-gray-700 border rounded-md">
              <h3 class="text-sm">¿A quién le vamos a reclamar?</h3>
            </div>
            <h3 class="text-sm pt-2">Datos del vehículo responsable</h3>
            <div class="flex flex-wrap pb-2">
              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="claim.patent" type="text" placeholder="Patente" :class="errors.patent != null ? 'border-red-500' : ''" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                  <span v-if="errors.patent != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.patent }}
                  </span>
              </div>

              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <select v-model="claim.insurance_id" :class="errors.insurance != null ? 'border-red-500' : ''" class="text-sm w-3/4 block appearance-none bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                    <option value="null" disabled>Compañia de Seguro</option>
                    <option v-for="i in insurances" :key="i.id" :value="i.id">{{ i.name }}</option>
                  </select>
                  <span v-if="errors.insurance != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.insurance }}
                  </span>
              </div>
            </div>

            <div class="flex justify-between items-center px-5 py-3 bg-green-50 text-gray-700 border rounded-md">
              <h3 class="text-sm">¿Como te desplazabas?</h3>
            </div>
            <div class="flex flex-wrap pb-2">
                <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <select :disabled="claim.id != null && !modalTrace" @change="changeDisplacementType" v-model="claim.displacement_type_id" :class="errors.displacement_type_id != null ? 'border-red-500' : ''" class="text-sm w-3/4 block appearance-none bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                    <option value="null" disabled>Seleccione...</option>
                    <option v-for="dt in displacementTypes" :key="dt.id" :value="dt.id">{{ dt.name }}</option>
                  </select>
                  <span v-if="errors.displacement_type_id != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.displacement_type_id }}
                  </span>
                </div>
            </div>

            
            <div class="flex justify-between items-center px-5 py-3 bg-green-50 text-gray-700 border rounded-md">
              <h3 class="text-sm">¿Qué vamos a reclamar?</h3>
            </div>
            <div class="flex flex-wrap pt-2 pb-2">
              <table class="min-w-full">
                <tbody :class="errors.types != null ? 'border border-t border-red-600' : ''">
                  <tr v-for="each in types" :key="each.id">
                    <td 
                      class="text-xs text-blue-800 border-gray-200 bg-gray-200">
                      {{ each.name }}
                    </td>
                    <td
                      class="text-xs text-black-800 border-gray-200 bg-gray-200">
                      {{ each.information }}
                    </td>
                    <td
                      class="text-xs text-green-600 border-gray-200 bg-gray-200">
                      {{ each.percentage }} % de Honorarios
                    </td>
                     <td
                      class="text-xs text-red-800 border-gray-200 bg-gray-200">
                      <input type="checkbox" @click="typeChange(each)" :disabled="claim.id" v-model="each.checked">
                     </td>
                  </tr>
                </tbody>
              </table>
              <span v-if="errors.types != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                {{ errors.types }}
              </span>
            </div>

            <div class="flex justify-between items-center px-5 py-3 bg-green-50 text-gray-700 border rounded-md">
              <h3 class="text-sm">¿Dónde ocurrió el accidente?</h3>
            </div>
            <div class="flex flex-wrap pt-2">
              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                <select @change="getCities()" v-model="province_id" :class="errors.province != null ? 'border-red-500' : ''" class="text-sm w-3/4 block appearance-none bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                  <option value="null" disabled>Seleccione una Provincia...</option>
                  <option v-for="p in provinces" :key="p.id" :value="p.id">{{ p.name }}</option>
                </select>
                <span v-if="errors.province != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                  {{ errors.province }}
                </span>
              </div>

              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                <select v-if="cities.length > 0" v-model="claim.city_id" :class="errors.city != null ? 'border-red-500' : ''" class="text-sm w-3/4 block appearance-none bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                  <option value="null" disabled>Seleccione una Localidad...</option>
                  <option v-for="c in cities" :key="c.id" :value="c.id">{{ c.name }} - {{ c.subname }}</option>
                </select>
                <span v-if="errors.city != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                  {{ errors.city }}
                </span>
              </div>

              <div class="pb-2 mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="claim.street_route" type="text" placeholder="Calle / Ruta" :class="errors.street_route != null ? 'border-red-500' : ''" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                  <span v-if="errors.street_route != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.street_route }}
                  </span>
              </div>
            </div>

            <div class="flex justify-between items-center px-5 py-3 bg-green-50 text-gray-700 border rounded-md">
              <h3 class="text-sm">¿Cuando ocurrió el accidente?</h3>
            </div>
            <div class="flex flex-wrap pt-2">
              <div class="pb-2 mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                <input v-model="claimDate" type="date" :class="errors.claimDate != null ? 'border-red-500' : ''" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                <span v-if="errors.claimDate != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                  {{ errors.claimDate }}
                </span>
              </div>

              <div class="pb-2 mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                <input v-model="claimTime" type="time" :class="errors.claimTime != null ? 'border-red-500' : ''" class="text-sm w-1/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                <span v-if="errors.claimTime != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                  {{ errors.claimTime }}
                </span>
              </div>
            </div>
            
            <div class="flex justify-between items-center px-5 py-3 bg-green-50 text-gray-700 border rounded-md">
              <h3 class="text-sm">¿Como ocurrió el accidente?</h3>
            </div>
            <div 
              @click="toogleCirculationType(item)" 
              class="pt-2" 
              v-show="index == currentIndex" 
              v-for="(item, index) in circulationTypes" :key="item.id">
              <center
                :class="[errors.displacement_circulation != null ? 'border-2 border-red-500' : '']"
              >
                <img 
                  :class="[claim.displacement_circulation_type_id == item.id ? 'border-4 border-green-500' : 'border-none']" 
                  class="w-2/4" 
                  :src="require('../assets/circulation_type/'+item.icon)" />
                <p v-if="item.title" class="text-sm text-blue-600">{{ item.title }}</p>
                <p v-if="item.description" class="text-sm text-gray-600">{{ item.description }}</p>
              </center>
            </div>
            <div class="pt-2" v-if="currentIndex == circulationTypes.length">
              <textarea 
                v-model="claim.displacement_circulation" 
                placeholder="Descripción del accidente" 
                :class="[errors.displacement_circulation != null ? 'border-1 border-red-500' : '']"
                class="min-w-full text-sm form-input appearance-none rounded-md focus:border-indigo-600" 
                rows="3">
              </textarea>
              <!--
              <audio v-if="claim.audio" controls>
                  <source :src="claim.audio" type="audio/mpeg">
                  El browser utilizado no soporta reproducción de audio.
              </audio>
              -->
            </div>
            <div>
              <div class="flex justify-between items-center">
                <svg 
                  @click="prevCirculation"
                  v-if="circulationTypes.length > 0"
                  :class="[currentIndex == 0 ? 'cursor-not-allowed text-gray-300' : 'cursor-pointer text-green-500']"
                  class="w-8 h-8 mr-2 -ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M11.739,13.962c-0.087,0.086-0.199,0.131-0.312,0.131c-0.112,0-0.226-0.045-0.312-0.131l-3.738-3.736c-0.173-0.173-0.173-0.454,0-0.626l3.559-3.562c0.173-0.175,0.454-0.173,0.626,0c0.173,0.172,0.173,0.451,0,0.624l-3.248,3.25l3.425,3.426C11.911,13.511,11.911,13.789,11.739,13.962 M18.406,10c0,4.644-3.763,8.406-8.406,8.406S1.594,14.644,1.594,10S5.356,1.594,10,1.594S18.406,5.356,18.406,10 M17.521,10c0-4.148-3.373-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.148,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.148,17.521,10"></path>
                </svg>
                <svg 
                  @click="nextCirculation"
                  v-if="circulationTypes.length > 0"
                  :class="[currentIndex == circulationTypes.length ? 'cursor-not-allowed text-gray-300' : 'cursor-pointer text-green-500']"
                  class="w-8 h-8 mr-2 -ml-1" fill="currentColor" viewBox="0 0 20 20">
                  <path d="M12.522,10.4l-3.559,3.562c-0.172,0.173-0.451,0.176-0.625,0c-0.173-0.173-0.173-0.451,0-0.624l3.248-3.25L8.161,6.662c-0.173-0.173-0.173-0.452,0-0.624c0.172-0.175,0.451-0.175,0.624,0l3.738,3.736C12.695,9.947,12.695,10.228,12.522,10.4 M18.406,10c0,4.644-3.764,8.406-8.406,8.406c-4.644,0-8.406-3.763-8.406-8.406S5.356,1.594,10,1.594C14.643,1.594,18.406,5.356,18.406,10M17.521,10c0-4.148-3.374-7.521-7.521-7.521c-4.148,0-7.521,3.374-7.521,7.521c0,4.147,3.374,7.521,7.521,7.521C14.147,17.521,17.521,14.147,17.521,10"></path>
                </svg>            
              </div>
            </div>
        </div>
        
        <div class="flex justify-end items-center px-5 py-3 bg-blue-50 border-t" v-if="accidentWho">
            <button 
              @click="saveClaim" 
              :disabled="loading" 
              :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
              type="button" 
              class="inline-flex rounded-md border border-green-300 px-4 py-2 bg-white text-sm leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg class="w-5 h-5 mr-2 -ml-1 text-white-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"></path>
              </svg>
              Aceptar
            </button>
        </div>
      </div>
    </div>

    <div class="pl-4 pr-4 pt-2" v-if="claim.id">
      <div class="w-full bg-white shadow-md rounded-md overflow-hidden border">
        <div class="flex justify-between items-center px-5 py-3 bg-blue-50 text-gray-700 border-b">
            <h3 class="text-sm">DOCUMENTACIÓN</h3>
            <button @click="documentShow = !documentShow">
                <svg class="h-4 w-4 text-gray-800 cursor-pointer" fill="currentColor" viewBox="0 0 24 24">
                    <path v-if="documentShow" d="M14.776,10c0,0.239-0.195,0.434-0.435,0.434H5.658c-0.239,0-0.434-0.195-0.434-0.434s0.195-0.434,0.434-0.434h8.684C14.581,9.566,14.776,9.762,14.776,10 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.691-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.382,10c0-4.071-3.312-7.381-7.382-7.381C5.929,2.619,2.619,5.93,2.619,10c0,4.07,3.311,7.382,7.381,7.382C14.07,17.383,17.382,14.07,17.382,10"></path>
                    <path v-if="!documentShow" d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10"></path>
                </svg>
            </button>
        </div>

        <div class="px-5 py-6 bg-gray-100" v-if="documentShow">
            <div class="flex flex-wrap">
              <table class="min-w-full">
                <thead v-for="f in claimFiles" :key="f.id">
                  <tr @click="toogleFileOptions(f)">
                    <th
                      class="flex items-center justify-between px-6 py-3 text-xs font-medium leading-4 tracking-wider text-orange-500 uppercase border-b border-orange-200 bg-orange-50"
                    >
                      <img v-if="f.icon" :src="require('../assets/files/'+f.icon)" />
                      <span>{{ f.name }}</span>
                      <svg
                        class="w-5 h-5 mr-2 -ml-1 text-white-400 cursor-pointer"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                      >
                        <path
                          v-if="!f.active"
                          d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10"
                        ></path>
                        <path 
                          v-if="f.active"
                          d="M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z M13.388,9.624H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h6.775c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z">
                        </path>
                      </svg>
                    </th>
                  </tr>
                  <tr v-for="o in f.options" :key="o.id" v-show="f.active">
                    <td
                      :class="[o.loaded ? 'text-gray-500' : 'text-red-500']"
                      class="flex items-center justify-between px-6 py-3 text-xs font-medium leading-4 tracking-wider uppercase border-b border-gray-200 bg-gray-50">
                        {{ o.name }}
                        <span class="flex items-center">
                          <a v-if="!o.loaded && !o.plus" href="#" @click="uploadFile(o)" class="pr-2">
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-green-500"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M8.416,3.943l1.12-1.12v9.031c0,0.257,0.208,0.464,0.464,0.464c0.256,0,0.464-0.207,0.464-0.464V2.823l1.12,1.12c0.182,0.182,0.476,0.182,0.656,0c0.182-0.181,0.182-0.475,0-0.656l-1.744-1.745c-0.018-0.081-0.048-0.16-0.112-0.224C10.279,1.214,10.137,1.177,10,1.194c-0.137-0.017-0.279,0.02-0.384,0.125C9.551,1.384,9.518,1.465,9.499,1.548L7.76,3.288c-0.182,0.181-0.182,0.475,0,0.656C7.941,4.125,8.234,4.125,8.416,3.943z M15.569,6.286h-2.32v0.928h2.32c0.512,0,0.928,0.416,0.928,0.928v8.817c0,0.513-0.416,0.929-0.928,0.929H4.432c-0.513,0-0.928-0.416-0.928-0.929V8.142c0-0.513,0.416-0.928,0.928-0.928h2.32V6.286h-2.32c-1.025,0-1.856,0.831-1.856,1.856v8.817c0,1.025,0.832,1.856,1.856,1.856h11.138c1.024,0,1.855-0.831,1.855-1.856V8.142C17.425,7.117,16.594,6.286,15.569,6.286z">
                              </path>
                            </svg>
                          </a>
                          <a v-if="o.loaded && !o.plus" href="#" @click="downloadFile(o)" class="pr-2">
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-green-500"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                              </path>
                            </svg>
                          </a>
                          <a v-if="o.loaded && !o.plus" href="#" @click="removeFile(o)">
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-red-500"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M12.71,7.291c-0.15-0.15-0.393-0.15-0.542,0L10,9.458L7.833,7.291c-0.15-0.15-0.392-0.15-0.542,0c-0.149,0.149-0.149,0.392,0,0.541L9.458,10l-2.168,2.167c-0.149,0.15-0.149,0.393,0,0.542c0.15,0.149,0.392,0.149,0.542,0L10,10.542l2.168,2.167c0.149,0.149,0.392,0.149,0.542,0c0.148-0.149,0.148-0.392,0-0.542L10.542,10l2.168-2.168C12.858,7.683,12.858,7.44,12.71,7.291z M10,1.188c-4.867,0-8.812,3.946-8.812,8.812c0,4.867,3.945,8.812,8.812,8.812s8.812-3.945,8.812-8.812C18.812,5.133,14.867,1.188,10,1.188z M10,18.046c-4.444,0-8.046-3.603-8.046-8.046c0-4.444,3.603-8.046,8.046-8.046c4.443,0,8.046,3.602,8.046,8.046C18.046,14.443,14.443,18.046,10,18.046z">
                              </path>
                            </svg>
                          </a>
                          <a v-if="o.plus && o.loaded && othersUploads.typeFileId != f.id" href="#" @click="viewOthersUpload(o)" class="pr-2">
                            <svg
                              class="w-6 h-6 mr-2 -ml-1 text-gray-500"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10,6.978c-1.666,0-3.022,1.356-3.022,3.022S8.334,13.022,10,13.022s3.022-1.356,3.022-3.022S11.666,6.978,10,6.978M10,12.267c-1.25,0-2.267-1.017-2.267-2.267c0-1.25,1.016-2.267,2.267-2.267c1.251,0,2.267,1.016,2.267,2.267C12.267,11.25,11.251,12.267,10,12.267 M18.391,9.733l-1.624-1.639C14.966,6.279,12.563,5.278,10,5.278S5.034,6.279,3.234,8.094L1.609,9.733c-0.146,0.147-0.146,0.386,0,0.533l1.625,1.639c1.8,1.815,4.203,2.816,6.766,2.816s4.966-1.001,6.767-2.816l1.624-1.639C18.536,10.119,18.536,9.881,18.391,9.733 M16.229,11.373c-1.656,1.672-3.868,2.594-6.229,2.594s-4.573-0.922-6.23-2.594L2.41,10l1.36-1.374C5.427,6.955,7.639,6.033,10,6.033s4.573,0.922,6.229,2.593L17.59,10L16.229,11.373z">
                              </path>
                            </svg>
                          </a>
                          <a v-if="o.plus && o.loaded && othersUploads.typeFileId == f.id" href="#" @click="othersUploads.typeFileId = null" class="pr-2">
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-orange-500"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z M13.388,9.624H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h6.775c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z">
                              </path>
                            </svg>
                          </a>
                          <a v-if="o.plus && othersUploads.typeFileId != f.id" href="#" @click="uploadFile(o)" class="pr-2">
                            <svg
                              class="w-5 h-5 mr-2 -ml-1 text-blue-500"
                              fill="currentColor"
                              viewBox="0 0 20 20"
                            >
                              <path d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10">
                              </path>
                            </svg>
                          </a>
                        </span>
                    </td>
                  </tr>
                  <tr v-for="(other, index) in othersUploads.files" :key="other.name+index" v-show="othersUploads.typeFileId == f.id">
                    <td 
                      class="flex items-center justify-between px-6 py-3 text-black-500 text-xs font-medium leading-4 tracking-wider uppercase border-b border-gray-200 bg-gray-300">
                      {{ other.name }} {{ index+1 }}
                      <span class="flex items-center">
                        <a href="#" @click="downloadOtherFile(other)" class="pr-2">
                          <svg
                            class="w-5 h-5 mr-2 -ml-1 text-green-500"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M15.608,6.262h-2.338v0.935h2.338c0.516,0,0.934,0.418,0.934,0.935v8.879c0,0.517-0.418,0.935-0.934,0.935H4.392c-0.516,0-0.935-0.418-0.935-0.935V8.131c0-0.516,0.419-0.935,0.935-0.935h2.336V6.262H4.392c-1.032,0-1.869,0.837-1.869,1.869v8.879c0,1.031,0.837,1.869,1.869,1.869h11.216c1.031,0,1.869-0.838,1.869-1.869V8.131C17.478,7.099,16.64,6.262,15.608,6.262z M9.513,11.973c0.017,0.082,0.047,0.162,0.109,0.226c0.104,0.106,0.243,0.143,0.378,0.126c0.135,0.017,0.274-0.02,0.377-0.126c0.064-0.065,0.097-0.147,0.115-0.231l1.708-1.751c0.178-0.183,0.178-0.479,0-0.662c-0.178-0.182-0.467-0.182-0.645,0l-1.101,1.129V1.588c0-0.258-0.204-0.467-0.456-0.467c-0.252,0-0.456,0.209-0.456,0.467v9.094L8.443,9.553c-0.178-0.182-0.467-0.182-0.645,0c-0.178,0.184-0.178,0.479,0,0.662L9.513,11.973z">
                            </path>
                          </svg>
                        </a>
                        <a href="#" @click="removeOtherFile(other)">
                          <svg
                            class="w-5 h-5 mr-2 -ml-1 text-red-500"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M12.71,7.291c-0.15-0.15-0.393-0.15-0.542,0L10,9.458L7.833,7.291c-0.15-0.15-0.392-0.15-0.542,0c-0.149,0.149-0.149,0.392,0,0.541L9.458,10l-2.168,2.167c-0.149,0.15-0.149,0.393,0,0.542c0.15,0.149,0.392,0.149,0.542,0L10,10.542l2.168,2.167c0.149,0.149,0.392,0.149,0.542,0c0.148-0.149,0.148-0.392,0-0.542L10.542,10l2.168-2.168C12.858,7.683,12.858,7.44,12.71,7.291z M10,1.188c-4.867,0-8.812,3.946-8.812,8.812c0,4.867,3.945,8.812,8.812,8.812s8.812-3.945,8.812-8.812C18.812,5.133,14.867,1.188,10,1.188z M10,18.046c-4.444,0-8.046-3.603-8.046-8.046c0-4.444,3.603-8.046,8.046-8.046c4.443,0,8.046,3.602,8.046,8.046C18.046,14.443,14.443,18.046,10,18.046z">
                            </path>
                          </svg>
                        </a>
                      </span>
                    </td>
                  </tr>
                </thead>
              </table>
            </div>
          </div>

      </div>
    </div>

    <div class="pl-4 pr-4 pt-2" v-if="claim.id">
      <div class="w-full bg-white shadow-md rounded-md overflow-hidden border">
        <div class="flex justify-between items-center px-5 py-3 bg-blue-50 text-gray-700 border-b">
            <h3 class="text-sm">VICTIMAS</h3>
            <button @click="victimShow = !victimShow">
                <svg class="h-4 w-4 text-gray-800 cursor-pointer" fill="currentColor" viewBox="0 0 24 24">
                    <path v-if="victimShow" d="M14.776,10c0,0.239-0.195,0.434-0.435,0.434H5.658c-0.239,0-0.434-0.195-0.434-0.434s0.195-0.434,0.434-0.434h8.684C14.581,9.566,14.776,9.762,14.776,10 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.691-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.382,10c0-4.071-3.312-7.381-7.382-7.381C5.929,2.619,2.619,5.93,2.619,10c0,4.07,3.311,7.382,7.381,7.382C14.07,17.383,17.382,14.07,17.382,10"></path>
                    <path v-if="!victimShow" d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10"></path>
                </svg>
            </button>
        </div>
        <div class="flex justify-center bg-gray-50 py-1" v-if="victimShow && !victimNewShow">
            <button 
              @click="victimNewShow = true" 
              type="button" 
              class="inline-flex rounded-md border border-red-300 px-4 py-2 bg-white text-sm leading-6 font-medium text-red-700 shadow-sm hover:text-red-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
              <svg class="w-5 h-5 mr-2 -ml-1 text-white-400" fill="currentColor" viewBox="0 0 20 20">
                <path d="M13.388,9.624h-3.011v-3.01c0-0.208-0.168-0.377-0.376-0.377S9.624,6.405,9.624,6.613v3.01H6.613c-0.208,0-0.376,0.168-0.376,0.376s0.168,0.376,0.376,0.376h3.011v3.01c0,0.208,0.168,0.378,0.376,0.378s0.376-0.17,0.376-0.378v-3.01h3.011c0.207,0,0.377-0.168,0.377-0.376S13.595,9.624,13.388,9.624z M10,1.344c-4.781,0-8.656,3.875-8.656,8.656c0,4.781,3.875,8.656,8.656,8.656c4.781,0,8.656-3.875,8.656-8.656C18.656,5.219,14.781,1.344,10,1.344z M10,17.903c-4.365,0-7.904-3.538-7.904-7.903S5.635,2.096,10,2.096S17.903,5.635,17.903,10S14.365,17.903,10,17.903z">
                </path>
              </svg>
              Agregar Víctima
            </button>
        </div>
        <div class="px-5 py-6 bg-gray-100" v-if="victimNewShow">
            <div class="flex flex-wrap">
              <div class="flex w-full px-5 py-3 bg-green-50 text-gray-700 border rounded-md">
                <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="victim.identity_number" type="number" :class="errors.victimIdentityNumber != null ? 'border-red-500' : ''" placeholder="DNI" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                  <span v-if="errors.victimIdentityNumber != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.victimIdentityNumber }}
                  </span>
                </div>

                <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="victim.name" type="text" :class="errors.victimName != null ? 'border-red-500' : ''" placeholder="Nombre y Apellido" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
                  <span v-if="errors.victimName != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                    {{ errors.victimName }}
                  </span>
                </div>
              </div>
            </div>

            <div class="flex flex-wrap pt-2 pb-2">
              <table class="min-w-full">
                <tbody :class="errors.victimTypes != null ? 'border border-t border-red-600' : ''">
                  <tr v-for="each in victimTypes" :key="each.id">
                    <td 
                      class="text-xs text-blue-800 border-gray-200 bg-gray-200">
                      {{ each.name }}
                    </td>
                    <td
                      class="text-xs text-black-800 border-gray-200 bg-gray-200">
                      {{ each.information }}
                    </td>
                    <td
                      class="text-xs text-green-600 border-gray-200 bg-gray-200">
                      {{ each.percentage }} % de Honorarios
                    </td>
                     <td
                      class="text-xs text-red-800 border-gray-200 bg-gray-200">
                      <input type="checkbox" v-model="each.checked" @change="uncheckVictim(each)">
                     </td>
                  </tr>
                </tbody>
              </table>
              <span v-if="errors.victimTypes != null" class="flex items-center font-medium tracking-wide text-red-500 text-xs mt-1 ml-1">
                {{ errors.victimTypes }}
              </span>
            </div>
            <div class="flex justify-center bg-gray-100 py-1">
              <div class="pr-2">
                <button 
                  @click="saveVictim" 
                  type="button" 
                  class="flex justify-center px-4 py-2 rounded-md border border-green-300 bg-white text-sm leading-6 font-medium text-green-700 shadow-sm hover:text-green-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                  <svg class="w-5 h-5 mr-2 -ml-1 text-white-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03">
                    </path>
                  </svg>
                  Aceptar
                </button>
              </div>
              <div>
                <button 
                  @click="victimNewShow = false" 
                  type="button" 
                  class="flex justify-center px-4 py-2 rounded-md border border-red-300 bg-white text-sm leading-6 font-medium text-red-700 shadow-sm hover:text-red-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
                  <svg class="w-5 h-5 mr-2 -ml-1 text-white-400" fill="currentColor" viewBox="0 0 20 20">
                    <path d="M10.185,1.417c-4.741,0-8.583,3.842-8.583,8.583c0,4.74,3.842,8.582,8.583,8.582S18.768,14.74,18.768,10C18.768,5.259,14.926,1.417,10.185,1.417 M10.185,17.68c-4.235,0-7.679-3.445-7.679-7.68c0-4.235,3.444-7.679,7.679-7.679S17.864,5.765,17.864,10C17.864,14.234,14.42,17.68,10.185,17.68 M10.824,10l2.842-2.844c0.178-0.176,0.178-0.46,0-0.637c-0.177-0.178-0.461-0.178-0.637,0l-2.844,2.841L7.341,6.52c-0.176-0.178-0.46-0.178-0.637,0c-0.178,0.176-0.178,0.461,0,0.637L9.546,10l-2.841,2.844c-0.178,0.176-0.178,0.461,0,0.637c0.178,0.178,0.459,0.178,0.637,0l2.844-2.841l2.844,2.841c0.178,0.178,0.459,0.178,0.637,0c0.178-0.176,0.178-0.461,0-0.637L10.824,10z">
                    </path>
                  </svg>
                  Cancelar
                </button>
              </div>
            </div>
        </div>
        <div class="pl-1 pb-1 pr-1 flex flex-wrap -mx-4" v-if="claim.id && claim.victims && victimShow && claim.victims.length > 0">
          <div class="w-full mb-6 lg:mb-0 px-4 flex flex-col">
            <div class="flex-grow flex flex-col bg-white border-t border-b sm:rounded sm:border shadow overflow-hidden">
                <table class="min-w-full">
                  <thead>
                    <tr><th colspan="3" class="text-xs text-white border-red-200 bg-red-400">Otras Víctimas</th></tr>
                  </thead>
                  <tbody>
                    <tr v-for="victim in claim.victims" :key="victim.id">
                      <td 
                        class="flex items-center justify-between px-6 py-1 text-xs text-gray-700 font-medium leading-4 tracking-wider uppercase border-t border-red-200 bg-red-50">
                        {{ victim.person.name }}
                      </td>
                      <td
                        class="text-xs text-gray-800 border-t border-red-200 bg-red-50">
                        <span v-if="victim.type" class="text-xs font-xs leading-none max-w-full flex-initial">{{ victim.type.name }}</span>
                        <span v-if="victim.type2" class="text-xs font-xs leading-none max-w-full flex-initial"> - {{ victim.type2.name }}</span>
                      </td>
                      <td
                        class="border-t border-red-200 bg-red-50">
                          <svg
                            @click="viewFiles(victim)"
                            class="w-5 h-5 mr-2 -ml-1 text-white-400 cursor-pointer"
                            fill="currentColor"
                            viewBox="0 0 20 20"
                          >
                            <path d="M15.475,6.692l-4.084-4.083C11.32,2.538,11.223,2.5,11.125,2.5h-6c-0.413,0-0.75,0.337-0.75,0.75v13.5c0,0.412,0.337,0.75,0.75,0.75h9.75c0.412,0,0.75-0.338,0.75-0.75V6.94C15.609,6.839,15.554,6.771,15.475,6.692 M11.5,3.779l2.843,2.846H11.5V3.779z M14.875,16.75h-9.75V3.25h5.625V7c0,0.206,0.168,0.375,0.375,0.375h3.75V16.75z"></path>
                          </svg>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </div>
          </div>
        </div>
      </div>
    </div>
    
    <div class="pl-4 pr-4 pt-2" v-if="claim.id">
      <div class="w-full bg-white shadow-md rounded-md overflow-hidden border">
        <div class="flex justify-between items-center px-5 py-3 bg-blue-50 text-gray-700 border-b">
            <h3 class="text-sm">Datos del que te chocó</h3>
            <button @click="responsableShow = !responsableShow">
                <svg class="h-4 w-4 text-gray-800 cursor-pointer" fill="currentColor" viewBox="0 0 24 24">
                    <path v-if="responsableShow" d="M14.776,10c0,0.239-0.195,0.434-0.435,0.434H5.658c-0.239,0-0.434-0.195-0.434-0.434s0.195-0.434,0.434-0.434h8.684C14.581,9.566,14.776,9.762,14.776,10 M18.25,10c0,4.558-3.693,8.25-8.25,8.25c-4.557,0-8.25-3.691-8.25-8.25c0-4.557,3.693-8.25,8.25-8.25C14.557,1.75,18.25,5.443,18.25,10 M17.382,10c0-4.071-3.312-7.381-7.382-7.381C5.929,2.619,2.619,5.93,2.619,10c0,4.07,3.311,7.382,7.381,7.382C14.07,17.383,17.382,14.07,17.382,10"></path>
                    <path v-if="!responsableShow" d="M14.613,10c0,0.23-0.188,0.419-0.419,0.419H10.42v3.774c0,0.23-0.189,0.42-0.42,0.42s-0.419-0.189-0.419-0.42v-3.774H5.806c-0.23,0-0.419-0.189-0.419-0.419s0.189-0.419,0.419-0.419h3.775V5.806c0-0.23,0.189-0.419,0.419-0.419s0.42,0.189,0.42,0.419v3.775h3.774C14.425,9.581,14.613,9.77,14.613,10 M17.969,10c0,4.401-3.567,7.969-7.969,7.969c-4.402,0-7.969-3.567-7.969-7.969c0-4.402,3.567-7.969,7.969-7.969C14.401,2.031,17.969,5.598,17.969,10 M17.13,10c0-3.932-3.198-7.13-7.13-7.13S2.87,6.068,2.87,10c0,3.933,3.198,7.13,7.13,7.13S17.13,13.933,17.13,10"></path>
                </svg>
            </button>
        </div>

        <div class="px-5 py-6 bg-gray-100" v-if="responsableShow">
            <div class="flex flex-wrap">
              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="responsable.identity_document" type="number" placeholder="DNI" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
              </div>

              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="responsable.name" type="text" placeholder="Nombre y Apellido" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
              </div>

              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="responsable.tel" type="text" placeholder="Teléfono" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
              </div>

              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                <select @change="getCitiesResponsable()" v-model="responsable.province_id" class="text-sm w-3/4 block appearance-none bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                  <option value="null" disabled>Seleccione una Provincia...</option>
                  <option v-for="p in provinces" :key="p.id" :value="p.id">{{ p.name }}</option>
                </select>
              </div>

              <div class="mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                <select v-if="reponsableCities.length > 0" v-model="responsable.city_id" class="text-sm w-3/4 block appearance-none bg-white border border-gray-400 hover:border-gray-500 px-4 py-2 pr-8 rounded shadow leading-tight focus:outline-none focus:shadow-outline">
                  <option value="null" disabled>Seleccione una Localidad...</option>
                  <option v-for="c in reponsableCities" :key="c.id" :value="c.id">{{ c.name }} - {{ c.subname }}</option>
                </select>
              </div>

              <div class="pb-2 mt-2 rounded-md w-full sm:w-1/2 md:w-1/3">
                  <input v-model="responsable.adress" type="text" placeholder="Domicilio" class="text-sm w-3/4 form-input py-2 appearance-none rounded-md focus:border-indigo-600">
              </div>
            </div>
        </div>

        <div class="flex justify-end items-center px-5 py-3 bg-blue-50 border-t" v-if="responsableShow">
          <button 
            @click="saveResponsable" 
            :disabled="loading" 
            :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
            type="button" 
            class="inline-flex rounded-md border border-green-300 px-4 py-2 bg-white text-sm leading-6 font-medium text-green-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
            <svg class="w-5 h-5 mr-2 -ml-1 text-white-400" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10.219,1.688c-4.471,0-8.094,3.623-8.094,8.094s3.623,8.094,8.094,8.094s8.094-3.623,8.094-8.094S14.689,1.688,10.219,1.688 M10.219,17.022c-3.994,0-7.242-3.247-7.242-7.241c0-3.994,3.248-7.242,7.242-7.242c3.994,0,7.241,3.248,7.241,7.242C17.46,13.775,14.213,17.022,10.219,17.022 M15.099,7.03c-0.167-0.167-0.438-0.167-0.604,0.002L9.062,12.48l-2.269-2.277c-0.166-0.167-0.437-0.167-0.603,0c-0.166,0.166-0.168,0.437-0.002,0.603l2.573,2.578c0.079,0.08,0.188,0.125,0.3,0.125s0.222-0.045,0.303-0.125l5.736-5.751C15.268,7.466,15.265,7.196,15.099,7.03"></path>
            </svg>
            Aceptar
          </button>
        </div>
      </div>
    </div>

    <div class="flex justify-end items-center px-5 py-3" v-if="isSysa && claim.id != null">
      <button 
        @click="remove" 
        :disabled="loading" 
        :class="[loading ? 'opacity-50 cursor-not-allowed' : 'hover:text-gray-500']"
        type="button" 
        class="inline-flex rounded-md border border-red-300 px-4 py-2 bg-white text-sm leading-6 font-medium text-red-700 shadow-sm hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue transition ease-in-out duration-150 sm:text-sm sm:leading-5">
        <svg class="w-5 h-5 mr-2 -ml-1 text-white-400" fill="currentColor" viewBox="0 0 20 20">
          <path d="M17.114,3.923h-4.589V2.427c0-0.252-0.207-0.459-0.46-0.459H7.935c-0.252,0-0.459,0.207-0.459,0.459v1.496h-4.59c-0.252,0-0.459,0.205-0.459,0.459c0,0.252,0.207,0.459,0.459,0.459h1.51v12.732c0,0.252,0.207,0.459,0.459,0.459h10.29c0.254,0,0.459-0.207,0.459-0.459V4.841h1.511c0.252,0,0.459-0.207,0.459-0.459C17.573,4.127,17.366,3.923,17.114,3.923M8.394,2.886h3.214v0.918H8.394V2.886z M14.686,17.114H5.314V4.841h9.372V17.114z M12.525,7.306v7.344c0,0.252-0.207,0.459-0.46,0.459s-0.458-0.207-0.458-0.459V7.306c0-0.254,0.205-0.459,0.458-0.459S12.525,7.051,12.525,7.306M8.394,7.306v7.344c0,0.252-0.207,0.459-0.459,0.459s-0.459-0.207-0.459-0.459V7.306c0-0.254,0.207-0.459,0.459-0.459S8.394,7.051,8.394,7.306"></path>
        </svg>
        Eliminar
      </button>
    </div>

  </div>
</template>

<script>
import Traces from '@/components/Traces'
import Upload from '@/components/Upload'
import MedicalView from '@/components/MedicalView'
import UserSearch from '@/components/UserSearch'
import AgreedAmount from '@/components/AgreedAmount'
import MercadoPago from '@/components/MercadoPago'
import SignAttachments from '@/components/SignAttachments'
import Vue from 'vue'
import VueAlertify from 'vue-alertify'
import { DisplacementTypesMap, ConstantMap } from '@/constant.js'
import '@/filter.js'

Vue.use(VueAlertify);

export default {
  components: { Upload, Traces, UserSearch, MedicalView, AgreedAmount, SignAttachments, MercadoPago },

  data() {
    return {
      userShow: true,
      accidentWho: true,
      documentShow: true,
      victimShow: true,
      responsableShow: true,
      victimNewShow: false,
      loading: false,
      modalTrace: false,
      modalMedicalView: false,
      modalVictim: false,
      modalMove: false,
      modalUser: false,
      modalAgreedAmount: false,
      modalSignAttachments: false,
      modalMercadoPago: false,
      errors: {
        email: null,
        name: null,
        identity_number: null,
        patent: null,
        insurance: null,
        displacement_type_id: null,
        types: null,
        province: null,
        city: null,
        street_route: null,
        claimDate: null,
        claimTime: null,
        displacement_circulation: null,
        victimName: null,
        victimIdentityNumber: null,
        victimTypes: null,
        valid: true,
      },
      user: {
        id: null,
        person: null,
        identity_number: null,
        name: null,
        tel: null,
        client: true
      },
      claim: {
        id: null,
        patent: null,
        insurance_id: null,
        displacement_type_id: null,
        other_person: false,
        city_id: null,
        street_route: null,
        date_hour: null,
        displacement_circulation_type_id: null,
        displacement_circulation: null,
        insured: null
      },
      victim: {
        id: null,
        name: null,
        insured: null
      },
      claimDate: null,
      claimTime: null,
      insurances: [],
      displacementTypes: [],
      circulationTypes: [],
      displacement: null,
      types: [],
      typesAux: [],
      provinces: [],
      province_id: null,
      cities: [],
      currentIndex: 0,
      claimFiles: [],
      modalUpload: false,
      optionSelected: null,
      victimTypes: [],
      chat: null,
      victimFiles: [],
      modalMoveError: null,
      linkMercadoPagoError: null, 
      stateSelected: null,
      states: [],
      isSysa: false,
      othersUploads: {
        typeFileId: null,
        files: []
      },
      othersVictimUploads: {
        typeFileId: null,
        files: []
      },
      responsable: {
        province_id: null,
        city_id: null
      },
      reponsableCities: [],
      stateInicial: ConstantMap.STATE_INICIAL,
      stateComplete: ConstantMap.STATE_COMPLETE,
      stateMedicalView: ConstantMap.STATE_MEDICAL_VIEW,
      stateNoOffer: ConstantMap.STATE_NO_OFFER,
      stateInNegotiation: ConstantMap.STATE_IN_NEGOTIATION,
      statePendingPayment: ConstantMap.STATE_PENDING_PAYMENT,
      statePendingCommission: ConstantMap.STATE_PENDING_COMMISSION,
      stateClosed: ConstantMap.STATE_CLOSED,
      linkMercadoPago: null
    }
  },

  mounted() {
    this.init()
    setInterval(() => {this.getChat()}, 60000)
    const user = JSON.parse(localStorage.getItem('user'))
    this.isSysa = (user.user.roles.indexOf("SYSA") !== -1)
  },

  methods: {
    init () {
      this.getInsurances()
      this.getDisplacementTypes()
      this.getTypes()
      this.getProvinces()
      this.getStates()
      if (this.$route.params.claimId){
        this.getDataClaim(this.$route.params.claimId)
      }
    },
    async getDataClaim(claimId) {
      this.loading = true
      const claim = await this.$http.get(`/claims/${claimId}`)
      const user  = await this.$http.get(`user/${claim.data.person.id}`)
      this.user = user.data
      this.user.identity_number = user.data.person.identity_number
      this.user.name = user.data.person.name
      this.user.tel = user.data.person.tel
      this.claim.id = claim.data.id
      this.claim.patent = claim.data.patent
      this.claim.code = claim.data.code
      this.claim.insurance_id = claim.data.insurance.id
      this.claim.displacement_type_id = claim.data.displacement_type.id
      this.province_id = claim.data.city.province.id
      this.cities = await this.$http.post(`/cities`, {params: `{"province_id": ${this.province_id}}`})
      this.claim.city_id = claim.data.city.id
      this.claim.street_route = claim.data.street_route
      this.claimDate = claim.data.date_hour.substring(0, 10)
      this.claimTime = claim.data.date_hour.substring(11, 16)
      this.circulationTypes = await this.$http.get(`/circulationType/circulations/${claim.data.displacement_type.id}`)
      if (claim.data.circulation_type != null){
        this.claim.displacement_circulation_type_id = claim.data.circulation_type.id
      }
      this.claim.displacement_circulation = claim.data.displacement_circulation
      this.claim.victims = claim.data.victims
      //this.claim.audio = claim.data.audio

      claim.data.types.forEach(t => {
        this.types.forEach(tc => {
          if (t.id == tc.id){
            if (t.id == ConstantMap.CLAIM_TYPE_MATERIAL_DAMAGE){
              this.victimTypes = this.types.filter(type => type.id != t.id)
            }
            tc.checked = true
          }
        })
      })
      this.chat = await this.$http.get(`chats/claim/${claimId}/noread`)
      this.claimFiles = await this.$http.get(`/type/files/${this.claim.id}`)
      this.claim.state = claim.data.state
      this.claim.driver = claim.data.driver
      this.responsable.name = claim.data.responsable.name
      this.responsable.identity_document = claim.data.responsable.identity_document
      this.responsable.tel = claim.data.responsable.tel
      this.responsable.adress = claim.data.responsable.adress
      if (claim.data.responsable.city != null){
        this.reponsableCities = await this.$http.post(`/cities`, {params: `{"province_id": ${claim.data.responsable.city.province.id}}`})
        this.responsable.city_id = claim.data.responsable.city.id
        this.responsable.province_id = claim.data.responsable.city.province.id
      }
      this.claim.types = claim.data.types
      this.claim.person = claim.data.person
      this.claim.medical = claim.data.medical
      this.claim.medical_date_hour = claim.data.medical_date_hour
      this.claim.medical_assist = claim.data.medical_assist
      this.claim.insured = claim.data.insured
      this.claim.amount_agreed = claim.data.amount_agreed
      this.claim.amount_commission = claim.data.amount_commission
      this.victimTypes.forEach(t => {
        t.checked = false
      })
      this.loading = false
    },
    async getStates() {
      this.states = await this.$http.get('/claimState/all')
    },
    async getChat() {
      if (this.claim.id != null){
        this.chat = await this.$http.get(`chats/claim/${this.claim.id}/noread`)
      }
    },
    async getInsurances() {
      this.insurances = await this.$http.get(`/insurance/all`)
    },
    async getDisplacementTypes() {
      this.displacementTypes = await this.$http.get(`/displacementType/all`)
    },
    async getTypes(){
      this.types = await this.$http.get(`/claimType/all`)
      this.typesAux = this.types
      const victimTypes = await this.$http.get(`/claimType/all`)
      let aux = []
      victimTypes.forEach(type => {
        type.checked = false
        aux.push(type)
      })
      this.victimTypes = aux
    },
    async getProvinces(){
      this.provinces = await this.$http.post(`/provinces`)
    },
    async getCities(){
      this.errors.city = null
      this.claim.city_id = null
      this.cities = []
      this.loading = true
      this.cities = await this.$http.post(`/cities`, {params: `{"province_id": ${this.province_id}}`})
      this.loading = false
    },
    async getCitiesResponsable(){
      this.responsable.city_id = null
      this.reponsableCities = []
      this.loading = true
      this.reponsableCities = await this.$http.post(`/cities`, {params: `{"province_id": ${this.responsable.province_id}}`})
      this.loading = false
    },
    async changeDisplacementType(){
      this.claim.driver = null
      if (this.claim.displacement_type_id == DisplacementTypesMap.MOTORCYCLE ||
          this.claim.displacement_type_id == DisplacementTypesMap.BIKE ||
          this.claim.displacement_type_id == DisplacementTypesMap.CAR ||
          this.claim.displacement_type_id == DisplacementTypesMap.BUS)
      {
        this.$alertify.confirmWithTitle(
          '¿Como te desplazabas?',
          `¿Ibas como Conductor?`,
          async () => {
            this.claim.driver = true
          },
          async () => {
           this.claim.driver = false
          }
        ).set('labels', {ok:'Si', cancel:'No'});
      }
      this.currentIndex = 0
      this.types = this.typesAux
      if (this.claim.displacement_type_id == DisplacementTypesMap.WALKING || 
          this.claim.displacement_type_id == DisplacementTypesMap.TRAIN){
          this.types = this.types.filter(type => type.id != ConstantMap.CLAIM_TYPE_MATERIAL_DAMAGE)
      }
      this.circulationTypes = await this.$http.get(`/circulationType/circulations/${this.claim.displacement_type_id}`)
    },
    cleanErrors() {
      this.loading = false
      this.errors = {
        email: null,
        name: null,
        identity_number: null,
        patent: null,
        insurance: null,
        displacement_type_id: null,
        types: null,
        province: null,
        city: null,
        street_route: null,
        claimDate: null,
        claimTime: null,
        displacement_circulation: null,
        victimName: null,
        victimIdentityNumber: null,
        victimTypes: null,
        valid: true,
      }
    },
    validateEmail(email) {
      const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
      return re.test(email);
    },
    validateFormClaim() {
      this.cleanErrors()
      let valid = true

      if (this.claim.patent == '' || this.claim.patent == null){
        this.errors.patent = "Patente Requerida!"
        valid = false
      }

      if (this.claim.insurance_id == null){
        this.errors.insurance = "Compañia de Seguro Requerida!"
        valid = false
      }

      if (this.claim.displacement_type_id == null){
        this.errors.displacement_type_id = "Seleccione como se desplazaba!"
        valid = false
      }

      let typesChecked = false
      this.types.forEach(type => {
        if (type.checked){
          typesChecked = true
        }
      })
      if (!typesChecked) {
        this.errors.types = "Seleccione que vamos a reclamar!"
      }

      if (this.province_id == null){
        this.errors.province = "Seleccione una Provincia!"
        valid = false
      } else {
        if (this.claim.city_id == null){
          this.errors.city = "Seleccione una Localidad!"
          valid = false
        }
      }

      if (this.claim.street_route == '' || this.claim.street_route == null){
        this.errors.street_route = "Calle / Ruta Requerida!"
        valid = false
      }

      if (this.claimDate == '' || this.claimDate == null){
        this.errors.claimDate = "Fecha Requerida!"
        valid = false
      }

      if (this.claimTime == '' || this.claimTime == null){
        this.errors.claimTime = "Hora Requerida!"
        valid = false
      }

      if ((this.claim.displacement_circulation == '' || this.claim.displacement_circulation == null)
         && (this.claim.displacement_circulation_type_id == null)){
           this.errors.displacement_circulation = "Requerido!"
           valid = false
      }
      
      return valid

    },
    validateFormUser() {
      this.cleanErrors()
      let valid = true

      if (this.user.email == '' || this.user.email == null){
        this.errors.email = "Email Requerido!"
        valid = false
      } else {
          if (!this.validateEmail(this.user.email)){
            this.errors.email = "Email Inválido!"
            valid = false
          }
      }

      if (this.user.identity_number == '' || this.user.identity_number == null){
        this.errors.identity_number = "DNI Requerido!"
        valid = false
      }

      if (this.user.name == '' || this.user.name == null){
        this.errors.name = "Nombre y Apellido Requerido!"
        valid = false
      }

      this.errors.valid = valid
      return valid
    },
    async saveUser() {
      if (this.validateFormUser()){
        if (this.user.id == null){
          try {
            this.loading = true
            const response = await this.$http.post('/users', this.user)
            this.user.id = response.data.id
            this.user.person = response.data.person
            this.$alertify.success('El usuario ha sido creado!')
            this.userShow = false
          } catch (error) {
            if (error.response.status == 422){
              this.errors.valid = false
              this.errors.email = 'El email ya existe.'
            } else {
              this.$alertify.error('ERROR. No se ha podido crear el usuario!')
            }
          } finally {
            this.loading = false
          }
        } else {
          try {
            this.loading = true
            await this.$http.put(`/users/${this.user.id}`, this.user)
            this.userShow = false
            this.$alertify.success('El usuario ha sido modificado!')
          } catch (error) {
            this.errors.valid = false
            this.errors.email = 'El email ya existe.'
          } finally {
            this.loading = false
          }
        }
      }
    },
    cleanOtherInsurance(){
      this.claim.insurance_id = null
      this.errors.insurance = null
    },
    typeChange(type) {
      this.claim.other_person = false
      if (type.id == 2 && !type.checked){
        this.$alertify.confirmWithTitle(
          '¿Iba con otras personas?',
          `En caso de sumarse al reclamo le vamos a estar consultando mediante mensaje`,
          async () => {
            this.claim.other_person = true
          }
        ).set('labels', {ok:'Si', cancel:'No'});
      }

      this.claim.insured = null
      if (type.id == 1 && !type.checked){
        this.$alertify.confirmWithTitle(
          '&nbsp;',
          '¿Su vehículo estaba asegurado al momento del accidente?.',
          async () => {
            this.claim.insured = true
          }, 
          async () => {
            this.claim.insured = false
          }
        ).set('labels', {ok:'Si', cancel:'No'});
      }
    },
    async saveClaim() {
      if (this.validateFormClaim()){
        const types = this.types.filter(item => item.checked == true)
        this.claim.types = JSON.stringify(types)
        this.claim.date_hour = this.claimDate+' '+this.claimTime+':00'
        this.claim.person_id = this.user.person.id
        if (this.claim.insurance_id == 0){
          this.claim.insurance_id = null
        }
        if (this.claim.id == null){
          try {
            this.loading = true
            const response = await this.$http.post('/claims/admin/create', this.claim)
            this.claim.id = response.data.id
            this.claim.victims = []
            this.claim.state = response.data.state
            this.$alertify.success('El Reclamo ha sido creado!')
            this.accidentWho = false
            this.claimFiles = await this.$http.get(`/type/files/${this.claim.id}`)
            this.saveFiles()
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido crear el Reclamo!')
          } finally {
            this.loading = false
          }
        } else {
          try {
            this.loading = true
            this.claim.date_hour = this.claimDate+' '+this.claimTime+':00'
            const resp = await this.$http.patch(`/claims/${this.claim.id}`, this.claim)
            this.getDataClaim(resp.data.id)
            this.$alertify.success('El Reclamo ha sido modificado!')
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido actualizar el Reclamo!')
          } finally {
            this.loading = false
          }
        }
      }
    },
    nextCirculation() {
      if (this.currentIndex  < this.circulationTypes.length){
        ++this.currentIndex
      }
    },
    prevCirculation() {
      if (this.currentIndex > 0){
        --this.currentIndex
      }
    },
    async saveFiles() {
       const params = {
        'claim_files': JSON.stringify(this.claimFiles)
       }
       await this.$http.put(`/claims/${this.claim.id}/files`, params)
    },
    toogleFileOptions(fileOptions) {
      fileOptions.active = !fileOptions.active
    },
    async downloadFile(option){
      const params = {
        file_option_id : option.id
      }
      const response = await this.$http.get(`claims/${this.claim.id}/file`, {params: params})
      
      const linkSource = response.data.file
      const downloadLink = document.createElement("a");
      
      downloadLink.href = linkSource;
      downloadLink.download = option.name;
      downloadLink.click();
    },
    removeFile(option){
      const params = {
        file_option_id : option.id
      }

      this.$alertify.confirmWithTitle(
        'Eliminar Documento',
        `¿Esta seguro que desea eliminar el documento ${option.name}?`,
        async () => {
          try {
            await this.$http.delete(`/claims/${this.claim.id}/remove/file`, {params: params})
            option.loaded = false
            this.$alertify.success('El documento ha sido eliminado!') 
            this.claimFiles = await this.$http.get(`/type/files/${this.claim.id}`)
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido eliminar el documento!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    async uploadFile(option){
     this.optionSelected = option
     this.modalUpload = true
    },
    closeModalUpload(upload){
      this.modalUpload = false
      if (upload){
        this.optionSelected.loaded = true
      }
      this.optionSelected = null
    },
    toogleCirculationType(item){
      this.errors.displacement_circulation = null
      if (this.claim.displacement_circulation_type_id == item.id){
        this.claim.displacement_circulation_type_id = null
      } else {
        this.claim.displacement_circulation_type_id = item.id
      }
    },
    validateFormVictim() {
      this.cleanErrors()
      let valid = true

      if (this.victim.identity_number == '' || this.victim.identity_number == null){
        this.errors.victimIdentityNumber = "DNI Requerido!"
        valid = false
      }

      if (this.victim.name == '' || this.victim.name == null){
        this.errors.victimName = "Nombre y Apellido Requerido!"
        valid = false
      }

      let typesChecked = false
      this.victimTypes.forEach(type => {
        if (type.checked){
          typesChecked = true
        }
      })
      if (!typesChecked) {
        valid = false
        this.errors.victimTypes = "Seleccione que vamos a reclamar!"
      }
      
      return valid
    },
    uncheckVictim(typeSelected){
      if (typeSelected.id != ConstantMap.CLAIM_TYPE_MATERIAL_DAMAGE){
        this.victimTypes.forEach((type) => {
          if ((type.id != typeSelected.id) && (type.id != ConstantMap.CLAIM_TYPE_MATERIAL_DAMAGE)){
            type.checked = false
          }
        })
      } else {
        if (typeSelected.checked){
          this.$alertify.confirmWithTitle(
              '&nbsp;',
              '¿Su vehículo estaba asegurado al momento del accidente?.',
              async () => {
                this.victim.insured = true
              }, 
              async () => {
                this.victim.insured = false
              }
            ).set('labels', {ok:'Si', cancel:'No'});
        }
      }
    },
    async saveVictim(){
      if (this.validateFormVictim()){
        try {
          this.loading = true

          let claim_type_id   = null
          let claim_type_2_id = null
          this.victimTypes.forEach(type => {
            if (type.checked){
              if (claim_type_id == null){
                claim_type_id = type.id
              } else {
                claim_type_2_id = type.id
              }
            }
          })      

          const params = {
            name: this.victim.name,
            identity_number: this.victim.identity_number,
            claim_type_id: claim_type_id,
            claim_type_2_id: claim_type_2_id,
            insured: this.victim.insured
          }

          const claimVictimResource = await this.$http.patch(`/claims/${this.claim.id}/victim`, params)
          this.claim.victims.push(claimVictimResource.data)
          this.victim.name = null
          this.victim.identity_number = null

          this.$alertify.success('La Víctima ha sido creada!')
          this.victimNewShow = false

          this.getDataClaim(this.claim.id)
        } catch (error) {
          this.$alertify.error('ERROR. No se ha podido crear la Víctima!')
        } finally {
          this.loading = false
        }
      }
    },
    async viewFiles(victim){
      this.modalVictim = true
      this.victim.id = victim.id
      this.victim.person = victim.person
      this.victimFiles = await this.$http.get(`claims/victim/${this.victim.id}/files`)
    },
    closeModalVictim() {
      this.modalVictim = false
      this.victim.id = null
      this.victim.person = null
    },
    async downloadVictimFile(option){
      const params = {
        file_option_id : option.id
      }
      const response = await this.$http.get(`claims/victim/${this.victim.id}/file`, {params: params})
      
      const linkSource = response.file
      const downloadLink = document.createElement("a");
      
      downloadLink.href = linkSource;
      downloadLink.download = option.name;
      downloadLink.click();
    },
    removeVictimFile(option){
      const params = {
        file_option_id : option.id
      }

      this.$alertify.confirmWithTitle(
        'Eliminar Documento',
        `¿Esta seguro que desea eliminar el documento ${option.name} de ${this.victim.person.name}?`,
        async () => {
          try {
            await this.$http.delete(`/claims/victim/${this.victim.id}/remove/file`, {params: params})
            option.loaded = false
            this.victimFiles = await this.$http.get(`claims/victim/${this.victim.id}/files`)
            this.$alertify.success('El documento ha sido eliminado!') 
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido eliminar el documento!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    move(){
      let valid = true
      let params = {
        claim_state_id: this.stateSelected.id
      }

      if (this.stateSelected == null){
        this.modalMoveError = "Debe seleccionar un estado!"
        valid = false
      } else {
        if (this.stateSelected.id == this.statePendingCommission){
          params.link_mercadopago = this.linkMercadoPago
          if (this.linkMercadoPago == null || this.linkMercadoPago == ''){
            this.linkMercadoPagoError = "Debe ingresar link de MercadoPago!"
            valid = false
          }
        } 
      } 
      
      if (valid){
        this.modalMoveError = null
        this.$alertify.confirmWithTitle(
          'Cambiar estado Reclamo',
          `¿Esta seguro que desea cambiar al estado ${this.stateSelected.name}?`,
          async () => {
            try {
              this.loading = true
              const resp = await this.$http.patch(`/claims/${this.claim.id}/state`, params)
              this.claim.state = resp.state
              this.$alertify.success('Cambio de estado realizado!') 
              this.loading = false
              this.modalMove = false
            } catch (error) {
              this.loading = false
              this.$alertify.error('ERROR. No se ha podido realizar el cambio de estado!')
            }   
          }
        ).set('labels', {ok:'Si', cancel:'No'});
      }
    },
    remove() {
      this.$alertify.confirmWithTitle(
        'Eliminar Reclamo',
        `¿Esta seguro que desea eliminar el reclamo ${this.claim.code}?`,
        async () => {
          try {
            this.loading = true
            const resp = await this.$http.delete(`/claims/${this.claim.id}`)
            this.claim = {
              id: null,
              patent: null,
              insurance_id: null,
              displacement_type_id: null,
              other_person: false,
              city_id: null,
              street_route: null,
              date_hour: null,
              displacement_circulation_type_id: null,
              displacement_circulation: null
            }
            this.claimDate = null
            this.claimTime = null
            this.province_id = null
            this.$alertify.success('Reclamo eliminado!') 
            this.loading = false
            this.$router.push({ name: 'Claims' })
          } catch (error) {
            this.loading = false
            this.$alertify.error('ERROR. No se ha podido eliminar el reclamo!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    closeModalUser(user) {
      this.modalUser = false
      if (user != null){
        this.user = user
        this.userShow = false
      }
    },
    async viewOthersUpload(option) {
      this.othersUploads.typeFileId = option.claim_type_files_id
      this.othersUploads.files = await this.$http.get(`type/files/${this.claim.id}/${option.id}`)
    },
    async downloadOtherFile(file){
      const response = await this.$http.get(`type/file/${file.id}`)
      
      const linkSource = response.data.file
      const downloadLink = document.createElement("a");
      
      downloadLink.href = linkSource;
      downloadLink.download = file.name;
      downloadLink.click();
    },
    removeOtherFile(file){
      this.$alertify.confirmWithTitle(
        'Eliminar Documento',
        `¿Esta seguro que desea eliminar el documento ${file.name}?`,
        async () => {
          try {
            await this.$http.delete(`/claims/${file.id}/file`)
            this.$alertify.success('El documento ha sido eliminado!') 
            this.othersUploads.typeFileId = null
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido eliminar el documento!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    async viewVictimOthersUpload(option) {
      this.othersVictimUploads.typeFileId = option.claim_type_files_id
      this.othersVictimUploads.files = await this.$http.get(`type/files/${this.victim.id}/${option.id}/victim`)
    },
    async downloadVictimOtherFile(file){
      const response = await this.$http.get(`type/file/${file.id}/victim`)
      
      const linkSource = response.file
      const downloadLink = document.createElement("a");
      
      downloadLink.href = linkSource;
      downloadLink.download = file.name;
      downloadLink.click();
    },
    removeVictimOtherFile(file){
      this.$alertify.confirmWithTitle(
        'Eliminar Documento',
        `¿Esta seguro que desea eliminar el documento ${file.name}?`,
        async () => {
          try {
            await this.$http.delete(`/claims/victim/${file.id}/file`)
            this.$alertify.success('El documento ha sido eliminado!') 
            this.othersVictimUploads.typeFileId = null
          } catch (error) {
            this.$alertify.error('ERROR. No se ha podido eliminar el documento!')
          }   
        }
      ).set('labels', {ok:'Si', cancel:'No'});
    },
    async saveResponsable(){
      try {
        this.loading = true

        const data = {
          'responsable_identity_document' : this.responsable.identity_document,
          'responsable_name' : this.responsable.name,
          'responsable_tel' : this.responsable.tel,
          'responsable_city_id' : this.responsable.city_id,
          'responsable_adress' : this.responsable.adress,
        }

        await this.$http.put(`/claims/${this.claim.id}/responsable`, data)

        this.$alertify.success('Datos del que chocó actualizados!')
      } catch (error) {
        this.$alertify.error('ERROR. No se ha podido actualizar los datos del que chocó!')
      } finally {
        this.loading = false
      }
    },
    refreshData(claimId){
      const currentState = this.states.filter(s => s.id == this.stateNoOffer)
      this.claim.state = currentState[0]
    },
    viewInfoPayment(claim){
      this.$alertify.alert(
        `${claim.code} - ${claim.state.name}`, 
        `<b>Monto Acordado</b><br>$ ${claim.amount_agreed}<br><br><b>Comisión</b><br>$ ${claim.amount_commission}`
      )
    }
  }
}
</script>
